import React from "react";
import '../ModalComponent.css';

const ModalComponent = ({ isOpen, onClose, title, modalDescription, modalPlanteamiento }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <span className="modal-close" onClick={onClose}>&times;</span>
                <h2>{title}</h2>
                <p className="descr"><strong>Contexto técnico: </strong>{modalDescription}</p>
                <p className="plante"><strong>Planteamiento del ejercicio: </strong> {modalPlanteamiento}</p>
            </div>
        </div>
    );
};

export default ModalComponent;
